export let relevantRecordsDetailCN: Record<string, Array<string>> = {
  "阿里巴巴 – 线上实习": [
    "阅读阿里巴巴 Java 开发手册，并将内容运用到项目前期的系统分析中。",
    "开发并实现一个小型的项目，运用到 Java SpringBoot, MySQL, Redis。"
  ],
  "网站后端开发实习 – 武汉找劳保网科技有限公司": [
    "运用 SpringMVC，MySQL 参与网站后端开发。",
    "参与原型图的设计，并在开发过程中与同事积极沟通，保证产出达到需求标准。"
  ],
  "讲师，学科面试官 – 海道（深圳）教育科技有限责任公司": [
    "Java 语言基础内容讲师。",
    "根据面试者的教学水平评判是否符合授课标准，并给予专业的建议。"
  ],
  "线上客服 – 深圳市鹏亮工贸有限公司": [
    "在线上解答客户的疑虑。",
    "帮助客户找到，定位最适合的产品。",
    "提供售后服务。"
  ],
  "志愿教学 – 深圳游子交流团": [
    "前往中国西部地区，甘肃省张掖市金川区，给予当地学生志愿教学。",
    "与其他志愿者一起给予当地学生数学，英文科目的帮助。"
  ]
};

export let relevantRecordsDetailEN: Record<string, Array<string>> = {
  "Alibaba one-month (remote) internship": [
    "Applying system analysis according to Alibaba’s java development manual",
    "Implemented a small-scale project using Java, MySQL, Redis."
  ],
  "Website back-end developer (internship)": [
    "Website back-end developing using Java, SpringMVC, MySQL.",
    "Understanding and completing design brief within set time frames.",
    "Communicating with colleague and supervisor to ensure meet of requirements."
  ],
  "Tutor, interviewer – HD Education": [
    "Teaching Java for beginners",
    "Evaluating candidates teaching abilities; Giving professional advice."
  ],
  "Online Sales": [
    "Answer customer queries online.",
    "Helping customers identify the best products.",
    "Helping customers identify the best products."
  ],
  "Volunteering Teaching": [
    "Spent two weeks teaching for kids on west part of China, Gansu.",
    "Working in a group to teach math and English to rural students."
  ]
};
